var App = App || {};

App.Animation = (function () {
    "use strict";

    function init() {
        App.ZagScrollAnimate.initialize('.blog-main-masthead', {
            offset: 75,
            targets: [
                { selector: ".masthead-area", type: "animate__fadeInUp", stagger: 333 }
            ],
            overflow: false
        });

        App.ZagScrollAnimate.initialize('.blogpost-list', {
            offset: 95,
            targets: [
                { selector: ".blogpost-card-wrapper", type: "animate__fadeInUp", stagger: 150 }
            ],
            overflow: false
        });

        App.ZagScrollAnimate.initialize('.landing-masthead', {
            offset: 75,
            targets: [
                { selector: ".landing-masthead-text-content", type: "animate__fadeIn", stagger: 0 },
                { selector: ".feature-card-wrapper", type: "animate__fadeInUp", stagger: 333 }
            ],
            overflow: false
        });

        App.ZagScrollAnimate.initialize('.widget-app-highlights', {
            offset: 75,
            targets: [
                { selector: ".feature-img", type: "animate__fadeIn", stagger: 0 }
            ],
            overflow: false
        });

        App.ZagScrollAnimate.initialize('.widget-blogpost-masthead', {
            offset: 75,
            targets: [
                { selector: ".masthead-image", type: "animate__fadeInUp", stagger: 0 }
            ],
            overflow: false
        });

        App.ZagScrollAnimate.initialize('.widget-community-band .community-band-community-features', {
            offset: 85,
            targets: [
                { selector: ".community-feature-wrapper", type: "animate__fadeInUp", stagger: 250 }
            ],
            overflow: false
        });

        App.ZagScrollAnimate.initialize('.widget-content-cards', {
            offset: 75,
            targets: [
                { selector: ".product-card", type: "animate__fadeInUp", stagger: 150 }
            ],
            overflow: false
        });

        App.ZagScrollAnimate.initialize('.widget-cross-promo', {
            offset: 66,
            targets: [
                { selector: ".cross-promo-content", type: "animate__fadeIn", stagger: 0 }
            ],
            overflow: false
        });

        App.ZagScrollAnimate.initialize('.widget-cta-callout-band', {
            offset: 80,
            targets: [
                { selector: ".cta-callout-card-wrapper", type: "animate__fadeInUp", stagger: 250 }
            ],
            overflow: false
        });

        App.ZagScrollAnimate.initialize('.widget-homepage-banner', {
            offset: 75,
            targets: [
                { selector: ".homepage-banner-primary-content", type: "animate__fadeIn", stagger: 0 },
                { selector: ".homepage-promo-wrapper", type: "animate__fadeInUp", stagger: 333 }
            ],
            overflow: false
        });

        App.ZagScrollAnimate.initialize('.widget-masthead', {
            offset: 50,
            targets: [
                { selector: ".feature-card-wrapper", type: "animate__fadeInUp", stagger: 250 }
            ],
            overflow: false
        });

        App.ZagScrollAnimate.initialize('.widget-product-finder', {
            offset: 75,
            targets: [
                { selector: ".product-card", type: "animate__fadeInUp", stagger: 150 }
            ],
            overflow: false
        });

        App.ZagScrollAnimate.initialize('.widget-proofpoints', {
            offset: 75,
            targets: [
                { selector: ".vc-item", type: "animate__fadeInUp", stagger: 500 }
            ],
            overflow: false
        });

        App.ZagScrollAnimate.initialize('.widget-rates-band .rates-carousel', {
            offset: 75,
            targets: [
                { selector: ".splide__slide", type: "animate__fadeIn", stagger: 333 }
            ],
            overflow: false
        });

        App.ZagScrollAnimate.initialize('.widget-resources-education .blogpost-cards', {
            offset: 66,
            targets: [
                { selector: ".blogpost-card-wrapper", type: "animate__fadeInUp", stagger: 333 }
            ],
            overflow: false
        });

        App.ZagScrollAnimate.initialize('.widget-resources-education .resources-group', {
            offset: 75,
            targets: [
                { selector: ".resource-item-outer", type: "animate__fadeIn", stagger: 250 }
            ],
            overflow: false
        });

        //parallax diamonds backgrounds
        if (document.querySelector(".WebPage_Blog .blog-bg-image-wrapper")) {
            App.ZagParallax.initialize('.WebPage_Blog', '.blog-bg-image-wrapper', { divisor: 6, offsetY: 100 });
        }
        if (document.querySelector(".section.blogpost-related .bg-image-wrapper")) {
            App.ZagParallax.initialize('.section.blogpost-related', '.bg-image-wrapper', { divisor: 6, offsetY: 100 });
        }
        if (document.querySelector(".widget-community-band .bg-image-wrapper")) {
            App.ZagParallax.initialize('.widget-community-band', '.bg-image-wrapper', { divisor: 6, offsetY: 100 });
        }
        if (document.querySelector(".section-default .bg-image-wrapper")) {
            App.ZagParallax.initialize('.section-default', '.bg-image-wrapper', { divisor: 5, offsetY: 100 });
        }
        if (document.querySelector(".widget-proofpoints .bg-image-wrapper")) {
            App.ZagParallax.initialize('.widget-proofpoints', '.bg-image-wrapper', { divisor: 6, offsetY: 150 });
        }
        if (document.querySelector(".widget-special-masthead .bg-image-wrapper")) {
            App.ZagParallax.initialize('.widget-special-masthead', '.bg-image-wrapper', { divisor: 6, offsetY: 75 });
        }

        //parallax images
        if (document.querySelector(".widget-blogpost-masthead .masthead-image")) {
            App.ZagParallax.initialize('.widget-blogpost-masthead', '.masthead-image', { divisor: 12 });
        }
        if (document.querySelector(".widget-homepage-banner .homepage-banner-primary-image")) {
            App.ZagParallax.initialize('.widget-homepage-banner', '.homepage-banner-primary-image', { divisor: 7 });
        }
        if (document.querySelector(".landing-masthead .landing-masthead-image")) {
            App.ZagParallax.initialize('.landing-masthead', '.landing-masthead-image', { divisor: 12 });
        }
        if (document.querySelector(".widget-masthead .masthead-image")) {
            App.ZagParallax.initialize('.widget-masthead', '.masthead-image', { divisor: 12 });
        }
        if (document.querySelector(".widget-proofpoints .main-img-wrapper")) {
            App.ZagParallax.initialize('.widget-proofpoints', '.main-img-wrapper', { divisor: 12 });
        }
        if (document.querySelector(".widget-special-masthead .special-masthead-image-parallax-wrapper")) {
            App.ZagParallax.initialize('.widget-special-masthead', '.special-masthead-image-parallax-wrapper', { divisor: 12 });
        }
    }

    return {
        init: init
    };
})();

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
        App.Animation.init();
    });
} else {
    App.Animation.init();
}